import React from "react";
import PropTypes from "prop-types";
import { AppUtils } from "@src/utils";
import { useAuthContext } from "@src/context";
import AdminHooks from "@src/context/hooks/adminHooks";
import {
  BackButton,
  Button,
  CustomerDropDown,
  DropDown,
  FormInput,
  Loader,
  TabSelector,
  Tag,
} from "@src/components/atoms";
import ErrorPage from "@src/components/layout/ErrorPage";
import { CardContainer } from "@src/components/cards";
import { UsersSection } from "../shared/UsersSection";
import NotificationList from "./NotificationList";
import OperatorSignupLinkCard from "./OperatorSignupLinkCard";

const OperatorTable = ({ operator }) => {
  if (!operator) return null;
  //skip metadata properties, OperatorMetadataTable will list them
  const keysToSkip = [
    "roleAlias",
    "vehicleEmail",
    "operatorName",
    "operatorLastName",
    "operatorEmail",
  ];
  return (
    <CardContainer padding={4} className="w-full">
      <h2>Operator properties</h2>
      <table className="w-full text-sm">
        <tbody>
          {Object.entries(operator)
            .filter(([key, _]) => !keysToSkip.includes(key))
            .map(([key, value]) => (
              <tr key={key}>
                <th className="text-left pr-2">{key}</th>
                <td>{String(value)}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </CardContainer>
  );
};
const OperatorMetadataTable = ({ operatorMetadata }) => {
  if (!operatorMetadata.length) return null;
  return (
    <CardContainer padding={4} className="w-full">
      <h2>Operator metadata</h2>
      <table className="w-full text-sm">
        <tbody>
          {operatorMetadata.map((m) => (
            <tr key={m.metadata_id} title={JSON.stringify(m, null, 2)}>
              <th className="text-left pr-2">{m.data_key}</th>
              <td>{m.data_value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </CardContainer>
  );
};

const UserDetailsPage = () => {
  const operatorId = location.pathname.split("/").pop();
  const auth = useAuthContext();

  const {
    data: operatorData,
    isPending,
    isError,
    //error: errorAll,
  } = AdminHooks.useGetOperator(auth.activeRole, operatorId);

  if (isPending) return <Loader />;
  if (isError) return <ErrorPage pageName="userDetails" />;

  if (operatorData?.operator == null) {
    <span>
      No operator found with id <code>{operatorId}</code>
    </span>;
  }

  const { operator, operatorMetadata } = operatorData;
  return (
    <section className="m-6 space-y-4">
      <div className="flex flex-row gap-4">
        <BackButton />
        <h2 className="grow">
          {operator.customerCode} Operator {operator.operatorCode}
        </h2>
      </div>

      <div className="flex md:flex-row items-start gap-5">
        <OperatorTable operator={operator} />
        <OperatorMetadataTable operatorMetadata={operatorMetadata} />
      </div>

      <OperatorSignupLinkCard
        operatorCode={operator.operatorCode}
        customerCode={operator.customerCode}
        operator={operator}
      />

      <NotificationList operator={operator} />
    </section>
  );
};

export default UserDetailsPage;
